module.exports = __webpack_public_path__ + "static/media/icon_homeAndGarden.536ebe80.svg";